export default __webpack_public_path__ + "static/media/496.27bcdffb.png";